package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SportsMartialArtsW500Rounded: ImageVector
    get() {
        if (_sportsMartialArtsW500Rounded != null) {
            return _sportsMartialArtsW500Rounded!!
        }
        _sportsMartialArtsW500Rounded = Builder(name = "SportsMartialArtsW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(511.24f, 485.98f)
                lineToRelative(-18.0f, 363.67f)
                quadToRelative(-1.0f, 17.44f, -13.7f, 29.39f)
                quadTo(466.85f, 891.0f, 445.41f, 891.0f)
                quadToRelative(-17.43f, 0.0f, -29.89f, -11.96f)
                quadToRelative(-12.45f, -11.95f, -13.69f, -29.39f)
                lineToRelative(-17.76f, -323.19f)
                lineToRelative(-128.68f, -73.96f)
                lineToRelative(-12.56f, 46.02f)
                lineToRelative(60.52f, 105.57f)
                quadToRelative(8.72f, 15.43f, 3.98f, 32.75f)
                quadToRelative(-4.74f, 17.31f, -20.18f, 26.27f)
                quadToRelative(-15.43f, 8.72f, -32.99f, 4.36f)
                quadToRelative(-17.55f, -4.36f, -26.27f, -19.8f)
                lineToRelative(-69.76f, -120.28f)
                quadToRelative(-4.72f, -7.96f, -5.96f, -17.03f)
                quadToRelative(-1.24f, -9.08f, 1.24f, -18.27f)
                lineToRelative(43.48f, -156.48f)
                lineToRelative(227.13f, -130.33f)
                lineToRelative(-78.65f, -78.89f)
                quadToRelative(-12.2f, -12.19f, -12.58f, -30.01f)
                quadToRelative(-0.38f, -17.81f, 12.82f, -31.01f)
                quadToRelative(12.19f, -12.2f, 30.39f, -12.2f)
                quadToRelative(18.2f, 0.0f, 30.39f, 12.2f)
                lineTo(523.72f, 181.7f)
                quadToRelative(16.15f, 15.91f, 13.17f, 38.04f)
                quadToRelative(-2.98f, 22.13f, -22.37f, 33.56f)
                lineToRelative(-92.3f, 53.18f)
                lineToRelative(49.43f, 41.04f)
                lineTo(769.5f, 104.2f)
                quadToRelative(12.2f, -10.96f, 29.01f, -9.22f)
                quadToRelative(16.82f, 1.74f, 30.01f, 17.17f)
                quadToRelative(9.96f, 11.96f, 9.34f, 27.27f)
                quadToRelative(-0.62f, 15.32f, -11.58f, 27.04f)
                lineTo(511.24f, 485.98f)
                close()
                moveTo(191.87f, 281.91f)
                quadToRelative(-34.44f, 0.0f, -59.13f, -24.69f)
                quadToRelative(-24.7f, -24.7f, -24.7f, -59.13f)
                quadToRelative(0.0f, -34.44f, 24.7f, -59.01f)
                quadToRelative(24.69f, -24.58f, 59.13f, -24.58f)
                quadToRelative(34.43f, 0.0f, 59.01f, 24.58f)
                quadToRelative(24.58f, 24.57f, 24.58f, 59.01f)
                quadToRelative(0.0f, 34.43f, -24.58f, 59.13f)
                quadToRelative(-24.58f, 24.69f, -59.01f, 24.69f)
                close()
            }
        }
        .build()
        return _sportsMartialArtsW500Rounded!!
    }

private var _sportsMartialArtsW500Rounded: ImageVector? = null
